<template>
<v-dialog v-model="dialog" width="500px" persistent>
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>
      <div class="text-center mt-5">
        Are you sure you want to remove Host {{eign.eign_code}} {{eign.eign_naam}} ?
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="warning"
          size="32"
          class="my-4 mx-auto d-block"
        />
        <div v-if="loading" class="mb-2" style="margin-top: 16px;">
          <span>removing host record...please wait</span>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmEign" :disabled="loading">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false" :disabled="loading">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      eign_encrid: null,
      loading: false,
      eign: {}
  }
  },
  methods: {
    open(eign_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/getEignToRmEign.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getEignToRmEign"
          },
          getEignToRmEign: {
            eign_encrid: eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.eign = res.data.getEignToRmEign;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmEign() { 
      this.loading = true;
      this.$axios
        .post("ares/json/ares/eign/rmEign.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmEign"
          },
          rmEign: {
            eign_encrid: this.eign.eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false
          }  else { 
            /* this.$router.reload('/eign/searchEign/'); */ 
            //  console.log('remove eign', res.data)
            //  this.$store.dispatch('setSnackbar', {
            //   showing: true,
            //   text: res.data.rmEign.text,
            //   color: res.data.rmEign.color
            // });
            this.loading = false
            this.dialog = false
            opener.location.reload()
            window.close()
          }
        })
    },
  }
}
</script>

